import { getWithRedirect, postWithRedirect } from 'utils/axios'
import Axios from 'axios'
import {
  TOrganizationalUnit,
  TOrganizationalUnitCreateRequest,
  TOrganizationalUnitGetResponse,
  TOrganizationalUnitUpdateRequest
} from 'types/GlobalOrganizationalUnit'
import { parseAuthenticationHeader } from 'helpers/Functions'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/organizational-units`

/**
 * Fetch all organizational units for the customer
 */
export const getOrganizationalUnits =
  async (): Promise<TOrganizationalUnitGetResponse> => {
    const response = await getWithRedirect<TOrganizationalUnitGetResponse>(URL)

    return response.data.data
  }

/**
 * Create a new organizational unit
 */
export const tryCreateOrganizationalUnit = async (
  data: TOrganizationalUnitCreateRequest
): Promise<TOrganizationalUnit> => {
  const response = await postWithRedirect<TOrganizationalUnit>(URL, { data })

  return response.data.data
}

/**
 * Update an organizational unit
 */
export const tryUpdateOrganizationalUnit = async (
  id: string,
  data: TOrganizationalUnitUpdateRequest
): Promise<TOrganizationalUnit> => {
  const response = await Axios.patch<{ data: TOrganizationalUnit }>(
    `${URL}/${id}`,
    { data },
    parseAuthenticationHeader()
  )

  return response.data.data
}

/**
 * Delete an organizational unit
 */
export const tryDeleteOrganizationalUnit = async (
  id: string
): Promise<void> => {
  await Axios.delete(`${URL}/${id}`, parseAuthenticationHeader())
}
